export interface AttachmentState {
  status: string,
}

export interface AttachmentResult {
  error: boolean,
  state: AttachmentState,
}

export const getDownloadURL = (mediaID: string, url: string) => `${url}/${mediaID}/download`;

export default async function getAttachmentURL(downloadUrl: string, token: string) {
  return fetch(downloadUrl, {
    method: 'GET',
    headers: {
      'X-ApiToken': token,
    },
    redirect: 'follow',
  });
}

export function createAttachmentURL(
  attachmentsURL: string,
  attachmentName: string,
  formId: string,
) {
  const params = new URLSearchParams({
    attached_to_type: 'form',
    form_id: formId,
    file_name: attachmentName,
    extension: '1',
  });
  return `${attachmentsURL}/view?${params}`;
}

export async function getAttachmentViewURL(attachmentsUrl: string, token: string) {
  const response = await getFullAttachmentInfo(attachmentsUrl, token);
  return response.url || null;
}

export async function getFullAttachmentInfo(attachmentsUrl: string, token: string) {
  const response = await fetch(attachmentsUrl, {
    method: 'GET',
    headers: {
      'x-apitoken': token,
    },
  });
  return response.json();
}

export const analyzeAttachmentState = (editing: boolean, response: any) => {
  if (response.status) {
    return response;
  }

  if (!response.error) {
    return { status: 'unknown' };
  }

  return editing && response.error === 'Unauthorized'
    ? { status: 'newattachment' }
    : { status: 'failed' };
};

export const getAttachmentInfo = async (mediaID: string, attachmentsUrl: string, token:string, editing: boolean) => {
  const result: AttachmentResult = { error: false, state: { status: 'unknown' } };
  const attachmentUrl = `${attachmentsUrl}/${mediaID}`;

  try {
    const response = await getFullAttachmentInfo(attachmentUrl, token);
    const state = analyzeAttachmentState(editing, response);
    result.state = state;
  } catch (e) {
    result.error = true;
    console.error('Failed to fetch attachment:', e);
  }

  return result;
};
